import type { ItemSource, OrderStatus } from '../../types';

export const STATUS_LABEL: Record<OrderStatus, string> = {
  created: 'Created',
  invoice_sent: 'Invoice sent',
  paid: 'Paid',
  in_progress: 'In progress',
  ready_for_pickup: 'Ready for pickup',
  shipped: 'Shipped',
  completed: 'Completed',
  cancelled: 'Cancelled',
  refunded: 'Refunded',
};

export const STATUS_ORDER: OrderStatus[] = [
  'created',
  'invoice_sent',
  'paid',
  'in_progress',
  'ready_for_pickup',
  'shipped',
  'completed',
  'cancelled',
  'refunded',
];

export const ITEM_SOURCE_LABEL: Record<ItemSource, string> = {
  customer_provided: 'Customer providing item',
  shop_provided: 'Shop providing item',
  unsure: 'Customer unsure',
  na: 'N/A',
};
